import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from 'react'
import { callApi, TApiResponse } from '../api'
import { useAuthContext } from '../auth'
import { IEeo, TEeoActions } from '../types'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialEeoState: IEeo = {
	genders: [],
	ethnicities: [],
	age_ranges: [],
	loading: false,
}

const EeoContext: Context<{
	eeo: IEeo
	actions: TEeoActions
}> = createContext({
	eeo: initialEeoState,
	actions: {
		// tslint:disable-next-line: no-empty
		allLists: () => {},
	},
})

export const EeoProvider = (props: PropsWithChildren<{}>) => {
	const { actions: authActions } = useAuthContext()
	const [eeo, setEeo] = useState<IEeo>(initialEeoState)

	const fetchEeo = useCallback(async () => {
		setEeo({ ...eeo, loading: true, error: null })
		const eeoResponse: TApiResponse = await callApi('eeo', {})

		const { data } = eeoResponse.payload

		if (eeoResponse.ok) {
			setEeo({
				genders: data.genders,
				ethnicities: data.ethnicities,
				age_ranges: data.age_ranges,
				loading: false,
				error: null,
			})
		} else {
			setEeo({
				...initialEeoState,
				error: data.message || 'Cannot get eeo',
				loading: false,
			})
			if (eeoResponse.status === 401) {
				authActions.logout()
			}
		}
	}, [authActions, eeo])

	const actions: TEeoActions = { allLists: fetchEeo }

	useEffect(() => actions.allLists(), [])

	return <EeoContext.Provider value={{ eeo, actions }}>{props.children}</EeoContext.Provider>
}

export const useEeoContext: () => { eeo: IEeo; actions: TEeoActions } = () => {
	return useContext(EeoContext)
}
